import type { RouteObject } from 'react-router-dom';
import { formatPhoneNumber } from '../format/PhoneNumber';
import { lazyElement } from '../routing/lazyRoute';
import { smsVoiceNumberPaths } from './paths';

const smsVoiceNumberRoutes: RouteObject[] = [
  {
    path: smsVoiceNumberPaths.list,
    element: lazyElement(() => import('./List')),
    handle: {
      documentTitle: 'SMS/Voice Numbers',
      crumb: () => ({ label: 'SMS/Voice Numbers', to: smsVoiceNumberPaths.list }),
    },
  },
  {
    path: smsVoiceNumberPaths.view,
    element: lazyElement(() => import('./View')),
    handle: {
      documentTitle: 'SMS/Voice Number',
      buildDocumentTitle: (params) => {
        const raw = params.phoneNumber;
        if (raw == null || raw.trim() === '') {
          return undefined;
        }
        return formatPhoneNumber(decodeURIComponent(raw));
      },
      crumb: () => ({ label: 'SMS/Voice Number' }),
    },
  },
  {
    path: smsVoiceNumberPaths.usageSummary,
    element: lazyElement(() => import('./Summary')),
    handle: {
      documentTitle: 'SMS/Voice Number Usage Summary',
      crumb: () => ({ label: 'Usage Summary', to: smsVoiceNumberPaths.usageSummary }),
    },
  },
  {
    path: smsVoiceNumberPaths.issues,
    element: lazyElement(() => import('./issues/Main')),
    handle: {
      documentTitle: 'SMS/Voice Number Issues',
      crumb: () => ({ label: 'Issues', to: smsVoiceNumberPaths.issues }),
    },
  },
];

export default smsVoiceNumberRoutes;
